<template>
  <v-dialog v-model="show"  >
    <v-card>
      <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
        <h2>Dispatch Group Allocations</h2>
        <v-spacer></v-spacer>
        <v-col cols="12" md="5">
          <v-switch class="justify-center" v-model="allSwitch" label="Show All" color="green"></v-switch>
        </v-col>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="show=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-container container--fluid grid-list-md>
          <v-row justify="center">
            <v-col cols="12" md="3"
                   :style="$vuetify.breakpoint.smAndDown ? 'background-color: #42424211;' :'background-color: #42424211; height: 90vh'">
                <v-card>
                  <v-list>
                    <v-list-item >
                      <v-list-item-content>
                        <v-list-item-title class="title">
                          Group
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                          <v-btn x-small class="mx-2" fab dark color="blue lighten-1" @click="newGroup">
                            <v-icon color="blue">add</v-icon>
                          </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-divider></v-divider>
                  <v-data-table
                    :headers="groupHeaders"
                    :items="renderedGroups"
                    hide-default-header
                    hide-default-footer
                    item-key="id"
                  >
                    <template v-slot:item="props">
                      <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}" >
                        <td 
                          style="text-align: center"
                          v-for="(header, index) in groupHeaders.filter(groupHeader => groupHeader.text !== 'Actions')" :key="index"
                          @click="groupSelected(props.item)"
                          :class="props.item[header.value] === selectedRow ? 'custom-highlight-row' : ''"
                        >
                          {{props.item[header.value]}}
                        </td>
                        
                        <td :style="props.item.id === selectedRowID ? 'background-color:skyblue' : ''">
                          <v-tooltip top color="secondary">
                            <template v-slot:activator="{ on }">
                              <v-icon small color="blue" @click="editGroup(props.item) " v-on="on">
                                edit
                              </v-icon>
                            </template>
                            <span>Edit</span>
                          </v-tooltip>
                          <v-tooltip top color="secondary">
                            <template v-slot:activator="{ on }">
                              <v-icon small color="red" @click="deleteGroup(props.item)" v-on="on" class="pl-1">
                                delete
                              </v-icon>
                            </template>
                            <span>Delete</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" md="9">
                <v-card>
                  <v-card-title>
                        <h3>{{selectedRow === ''  ? 'Routes' : capitalizeFirstLetter(selectedRow) + '-- Routes'}}</h3>
                    <v-divider
                      class="mx-4"
                      inset
                      vertical
                    ></v-divider>
                      <v-col cols="12"
                             sm="6"
                             md="4">
                        <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
                      </v-col>
                      <v-spacer/>
                      <v-col cols="10" md="3" >
                        <v-tooltip top color="secondary">
                          <template v-slot:activator="{ on }">
                            <v-icon
                              large
                              color="blue"
                              @click="allocate" v-on="on"
                              :disabled="selected.length < 1 || selectedRowID == 0"
                            >share
                            </v-icon>
                          </template>
                          <span>Allocate</span>
                        </v-tooltip>
                      </v-col>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="renderedRoutes"
                      :search="search"
                      show-select
                      item-key="id"
                      v-model="selected"
                    >
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this group. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="toggleDelete" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog"  width="800px">
          <v-card>
            <v-card-title class="d-flex" style="position: relative" :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
              <h2>{{editedIndex > -1 ? 'Edit Group' : 'New Group'}}</h2>
              <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="editDialog=false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
              <v-container container--fluid grid-list-xl pb-0>
                <v-form
                  ref="form"
                  v-model="valid">
                  <v-row justify="space-around">
                      <v-col  cols="12" md="5">
                        <v-text-field
                          item-color="blue"
                          prepend-icon="speaker_notes"
                          label="Group Name"
                          v-model="newGroups.name"
                          :rules="requiredRule"
                        ></v-text-field>
                      </v-col>
                      <v-spacer></v-spacer>
                        <v-col  cols="12" md="5">
                          <v-dialog
                              ref="dialogFrom"
                              v-model="modalFrom"
                              :return-value.sync="dateSelected"
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="newGroups.time"
                                  label="Select Date"
                                  prepend-icon="event"
                                  :rules="requiredRule"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="newGroups.time"
                                scrollable :max="today"
                              >
                                <v-spacer></v-spacer>
                                <v-btn text color="blue-grey lighten-2" @click="modalFrom = false">Cancel</v-btn>
                                <v-btn text color="blue darken-1" @click="$refs.dialogFrom.save(newGroups.time)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                      </v-col>
                    </v-row>
                  <v-row justify="space-around">
                    <v-col  cols="12" md="5">
                      <v-menu
                        ref="timeStart"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="hours"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="hours"
                            label="time"
                            prepend-inner-icon="access_time"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-model="hours"
                          :allowed-minutes="minutes"
                          @click:minute="$refs.timeStart.save(hours)"></v-time-picker>
                      </v-menu>
                    </v-col>
                    </v-row>

                  <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
                    <v-col cols="12" md="3" class="text-center">
                      <v-btn
                        text
                        @click="editDialog=false"
                        color="blue-grey lighten-2"
                      >Cancel
                      </v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                      <v-btn
                        text
                        @click="saveGroup"
                        color="blue darken-1"
                      >Save
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  name: "AllocateRoute",
  props: {
    showDialog: Boolean,
    staging_id: Number,

  },
  data() {
    return {
      search:null,
      allSwitch: false,
      headers:[
        {text: 'Route Name', value: 'name', align: 'center', sortable: true},
        {text: 'Sort Code', value: 'sort_code', align: 'center', sortable: true},
        // {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],
      groupHeaders:[
        {text: 'Group', value: 'name', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],
      valid: false,
      reload: false,
      toBeDeleted:null,
      deleteDialog:false,
      editDialog:false,
      // selectedGroup:0,
      editedIndex: -1,
      // staging_id:16,
      newGroups:{
        name:null,
        time:null
      },
      hours:null,
      editGroups:{
        name:null,
        time:null
      },
      groupID:null,
      modalFrom:null,
      dateSelected:null,
      today: new Date().toISOString().substr(0, 10),
      requiredRule: [
        v => !!v || 'This field is required.'
      ],
      selected:[],
      selectedRow: '',
      selectedRowID:0,
      minutes:[0,15,30,45],

    }
  },
  methods: {
    groupSelected(item){
       this.selectedRow = item['name'];
       this.selectedRowID = item['id'];

    },
    editGroup(item){

      this.newGroups.name = item['name'];
      this.newGroups.time = item['time'].split(' ')[0];
      this.hours = item['time'].split(' ')[1];
      this.groupID = item['id'];
      this.editedIndex = this.renderedGroups.indexOf(item);
      this.editDialog = true;
    },
    newGroup(){
        this.editedIndex = -1;
        this.newGroups = Object.assign({}, this.editGroups);
        this.hours = null;
        this.editDialog = true;
    },
    deleteGroup(item){
        this.toBeDeleted = item;
        this.deleteDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    toggleDelete(){
        axios.delete(process.env.API_URL + '/lastmiledispatch/' + this.staging_id + '/groups/' + this.toBeDeleted.id)
          .then((response) => {
            this.updateDataTable();
            this.deleteDialog = false;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
          })
    },
    saveGroup(){
        this.newGroups.time = this.newGroups.time + ' ' +  this.hours;
        let body = this.newGroups;
        if (this.editedIndex > -1) {
          axios.put(process.env.API_URL + '/lastmiledispatch/'  + this.staging_id + '/groups/' + this.groupID, body)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'Changes saved.');
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            })
        } else {
          axios.post(process.env.API_URL + '/lastmiledispatch/' + this.staging_id + '/groups', body)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'Group created.');
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            })
        }
        this.editDialog = false;
    },
    capitalizeFirstLetter(string) {
      string = string.replace(/_/g, ' ');
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    allocate() {
      let body = {
        dispatch_group_id : this.selectedRowID,
      }
      if(this.selected.length > 0){
        this.selected.forEach( route => {
          axios.post(process.env.API_URL + '/lastmiledispatch/' + this.staging_id + '/routes/' + route.id + '/allocate', body)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'allocated.');
            })
            .catch((response) => {
              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            });
        });
      }
      this.selected = [];
    },
  },
  computed: {
    show: {
      get() {
        return this.showDialog
      },
      set() {
        this.$emit('close');
      }
    },
    renderedRoutes() {
      if (this.routes === null) return [];
      if(!this.allSwitch){
        let showAll = this.routes.filter((route) => {
          return route.dispatch_group_id == null;
        });
        return showAll;
      }
      else {
        if(this.selectedRowID != 0){
          let showGroup = this.routes.filter((route) => {
            return route.dispatch_group_id == this.selectedRowID;
          });
          return showGroup;
        }

        else return this.routes;
      }
    },
    renderedGroups() {
      if (this.group === null) return [];
      return this.group;
    },
  },
  asyncComputed: {
    async routes() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/lastmiledispatch/' + this.staging_id + '/routes' )
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    },
    async group() {
      if (this.reload || !this.reload) {

        return await axios.get(process.env.API_URL + '/lastmiledispatch/' + this.staging_id + '/groups')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
            return [];
          });
      }
    },

  }
}
</script>

<style scoped>

.custom-highlight-row{
  background-color: skyblue;
}


</style>



// WEBPACK FOOTER //
// src/components/util/AllocateRoute.vue